























import {Component, Prop, Vue} from 'vue-property-decorator';
import Carousel from '@/components/Views/Vendor/Carousel.vue';
import VendorProfileDialog from '@/components/Views/Vendor/VendorProfileDialog.vue';
import {Mixins} from 'vue-property-decorator';
import VendorMixin from '@/mixins/VendorMixin.vue';
import {multiNil, nil} from '@/common';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';

@Component({
    components: {
        VendorProfileDialog,
        Carousel,
    },
})
export default class VendorBox extends Mixins(VendorMixin, UserRoleMixin) {
    @Prop({
        default: () => {
            return undefined;
        },
    })
    public vendor!: any;

    @Prop({default: 'Book'})
    public bookAction!: string;

    @Prop({default: false})
    public bookable!: boolean;

    @Prop({default: false})
    public readonly!: boolean;

    @Prop({default: () => undefined})
    public callToAction!: string;

    @Prop({default: true})
    public callToActionBig!: boolean;

    @Prop({default: false})
    public externalDialog!: boolean;

    public slides = [];
    public created() {
        this.initImages();
    }

    public mounted() {
        this.initImages();
    }
    public bookedFromDialog(vendor) {
        this.$emit('onBook', vendor);
        (this.$refs.vendorProfile as any).open = false;
    }

    public async initImages() {
        const imgs = await this.vendorWorkImages(this.vendor);
        this.slides = imgs.map((x) => nil(x.thumb, true) ? x.file : x.thumb);
    }

    public openVendorDialog(vendor) {
        if (this.externalDialog) {
            this.$emit('openProfile', vendor);
        } else {
            (this.$refs.vendorProfile as any).openWith(vendor);
        }

    }

    public get vendorName() {
        return nil(this.vendor) ? '' : this.userIsAdmin ? `${this.vendor.firstName} ${this.vendor.lastName}` : this.vendor.firstName;
    }

    public get hasReviews() {
        return nil(this.vendor) ? false : !nil(this.vendor.reviewModels, true);
    }
    public get averageRating() {
        if (!this.hasReviews) {
            return '';
        }
        const sum = this.vendor.reviewModels.map((x) => x.rating).reduce((accumulator, currentValue) => {
            return accumulator + currentValue;
        });
        return Number((sum / this.vendor.reviewModels.length).toFixed(2));
    }
}
